import React from "react"

import ContentLines from "../content-loading/ContentLines"
import ListItemImageShadow from "../content-loading/ListItemImageShadow"

export default () => (
    <div className="list-group-item list-group-item-action align-items-start">
        <ListItemImageShadow />
        <div className="list-group-item-content">
            {/* title */}
            <ContentLines minLineLength={30} minLines={1} maxLines={2} />
            {/* time added */}
            <ContentLines lineLength={50} />
            {/* time published */}
            <ContentLines lineLength={60} />
            {/* publisher */}
            <ContentLines minLineLength={20} maxLineLength={60} />
            <div className="item-flag shadow" />
        </div>
    </div>
)
